let page_elements;
let recaptcha_site_key = $("meta[name='recaptcha-site-key']").attr("content");

const populate_country_select = (list) => {
    const placeholder = (text) => {
        const x = document.createElement("option");
        x.text = text;
        x.disabled = true;
        x.selected = true;
        x.hidden = true;
        return x;
    };
    const clearOptions = (element) => {
        element.innerHTML = "";
    };
    const populate_state_select = (country_code, state_default) => {
        if (country_code === null) return;
        const country = list.find((x) => x.code === country_code);

        if (country.states.length === 0) {
            const selection = document.createElement("option");
            selection.text = "Default";
            selection.value = "Default";
            selection.selected = true;
            state_selection.add(selection);
            $("#origin_state").next().hide();
            return;
        } else {
            const options = country.states.map((state) => {
                const option = document.createElement("option");
                option.text = state.name;
                option.value = state.code;
                option.selected = state_default === state.code;
                return option;
            });
            clearOptions(state_selection);
            [placeholder("Select your state"), ...options].map((option) =>
                state_selection.add(option)
            );
            $("#origin_state").next().show();
        }
    };

    const country_selection = document.getElementById("origin_country");
    const state_selection = document.getElementById("origin_state");

    const country_default = country_selection.children[0]?.value || null;
    const state_default = state_selection.children[0]?.value || null;

    country_selection.addEventListener("change", (e) => {
        const country_code = e.target.value;
        populate_state_select(country_code, null);
    });

    const options = list.map((country) => {
        const option = document.createElement("option");
        option.text = country.name;
        option.value = country.code;
        option.selected = country_default === country.code;
        return option;
    });

    clearOptions(country_selection);
    [placeholder("Select your country"), ...options].map((option) =>
        country_selection.add(option)
    );

    $("#origin_country").select2();
    $("#origin_state").select2();

    $("#origin_country").on("select2:select", (e) => {
        const country_code = e.target.value;
        populate_state_select(country_code, null);
    });

    state_selection.disabled = true;
    country_selection.disabled = true;
    state_default === null && $("#origin_state").next().hide();
    populate_state_select(country_default, state_default);
};
const country_state_list = () => {
    fetch("/assets/json/country_state.json")
        .then((res) => res.json())
        .then((list) => populate_country_select(list));
};

$(function () {
    country_state_list();
    $(".edit-profile").click(function () {
        $(".ui-profile-card").addClass("ui-profile-edit-active");
        $("#first_name").prop("readonly", false);
        $("#last_name").prop("readonly", false);
        $("#month").prop("disabled", false);
        $("#date").prop("disabled", false);
        $("#year").prop("disabled", false);
        $("#title").prop("disabled", false);
        $("#destination").prop("disabled", false);
        $("#origin_country").prop("disabled", false);
        $("#origin_state").prop("disabled", false);
        $("#inlineRadio1").prop("disabled", false);
        $("#inlineRadio2").prop("disabled", false);
        $("#inlineRadio3").prop("disabled", false);
        $("#inlineRadio4").prop("disabled", false);
        $("#inlineRadio5").prop("disabled", false);
        $("#inlineRadio6").prop("disabled", false);
        $("#inlineRadio7").prop("disabled", false);
        $("#email").prop("disabled", true);
        $("#phone").prop("disabled", true);
        $("#comment").prop("readonly", false);
        $(".save-button").removeClass("hide");
        $(".edit-profile").addClass("hide");

        // let year = new Date().getFullYear();
        // let topYear = year - 18;
        // var html = '';
        // for(var i = topYear - 50; i <= topYear; i++){
        //     html += '<option value="' + i + '">' + i + '</option>';
        // }
        // $('#year').html(html);
    });

    $(".ui-cancel-btn").click(function () {
        disableFormFields();
    });

    $(document).ready(function () {
        $("#js-delete-cancel").on("click", function (e) {
            e.preventDefault();
        });

        $("#delete-account-one").on("show.bs.modal", function (e) {
            if (window.innerWidth < 991) {
                if ($("#res-delete-title").val() == "") {
                    $("#res-delete-title").parent().addClass("is-invalid");
                    return e.preventDefault();
                } else {
                    $("#res-delete-title").parent().removeClass("is-invalid");
                }
            } else {
                if ($("#delete-title").val() == "") {
                    $("#delete-title").parent().addClass("is-invalid");
                    return e.preventDefault();
                } else {
                    $("#delete-title").parent().removeClass("is-invalid");
                }
            }
        });
    });

    // remove required message in validation
    $.validator.messages.required = "";

    page_elements = {
        update_profile: {
            form: $("#updateProfile"),
        },
        update_password: {
            form: $("#updatePassword"),
        },
        email_or_mobile: $(".js-email-or-phone"),
        password_eye: $(".js-password-toggle-btn"),
        otp_input_wrap: $(".js-otp-inputs-wrap"),
    };

    initFormEvents();
    initValidation(); // validation initalize
    // initPasswordValidation();

    // contry code select init

    countryCodeInput($("#email_mobile_username"));
    countryCodeInput($("#phone"));
    countryCodeInput($("#phone1"));
    countryCodeInput($("#phone3"));

    page_elements.update_profile.form
        .not(":disabled")
        .on("submit", updateProfile);
    page_elements.update_password.form
        .not(":disabled")
        .on("submit", updatePassword);
});

/**
 * Initialise all input events
 *
 * @author Nishal K.R <nishal@webandcrafts.com>
 *
 * @param JSON page_elements - page element list
 *
 * @return void
 */
function initFormEvents() {
    // switch email and mobile input
    page_elements.email_or_mobile.on("keyup", function () {
        let $this = $(this);
        if ($.isNumeric($this.val())) {
            // $this.attr('type', 'text');
            $this.parents(".form-group").addClass("ui-isd-code-show");
        } else {
            // $this.attr('type', 'email');
            $this.parents(".form-group").removeClass("ui-isd-code-show");
        }
    });
    page_elements.email_or_mobile.on("blur", function () {
        let $this = $(this);
        if ($.isNumeric($this.val())) {
            $this.attr("type", "text");
        } else {
            $this.attr("type", "email");
        }
    });

    // switch password with text : password eye
    page_elements.password_eye.on("click", function () {
        let inpPass = $(this).parents(".js-password-wrap").find("input");
        inpPass.attr("type") == "password"
            ? inpPass.attr("type", "text")
            : inpPass.attr("type", "password");
    });

    // OTP input wrap
    page_elements.otp_input_wrap.each(function () {
        let that = $(this);
        $(this)
            .find("input")
            .each(function () {
                let otpInput = that.find("input"),
                    submit = that.parents("form").find('button[type="submit"]');
                $(this).attr("maxlength", 1);
                $(this).on("keyup", function (e) {
                    // let parent = $($(this).parent());

                    if (e.keyCode === 8 || e.keyCode === 37) {
                        let prev = that.find("input").eq($(this).index() - 1);
                        if (prev.length && $(this).index() != 0) {
                            $(prev).select();
                        }
                    } else if (
                        (e.keyCode >= 48 && e.keyCode <= 57) ||
                        (e.keyCode >= 65 && e.keyCode <= 90) ||
                        (e.keyCode >= 96 && e.keyCode <= 105) ||
                        e.keyCode === 39
                    ) {
                        let next = that.find("input").eq($(this).index() + 1);
                        if (next.length) {
                            $(next).select();
                        } else {
                            that.parents("form")
                                .find('button[type="submit"]')
                                .focus();
                        }
                    }
                    let thisInput = $(this);
                    if (!$(this).val()) {
                        thisInput.removeClass("js-input-active");
                    } else {
                        thisInput.addClass("js-input-active");
                    }
                    if (
                        otpInput.eq(0).val() &&
                        otpInput.eq(1).val() &&
                        otpInput.eq(2).val() &&
                        otpInput.eq(3).val() &&
                        otpInput.eq(4).val()
                    ) {
                        submit.removeClass("ui-disabled");
                    } else {
                        submit.addClass("ui-disabled");
                    }
                });
            });
    });
}

/**
 * Initialise all form validations
 *
 * @author Muhammed Niyas V<niyas@webandcrafts.in>
 *
 * @return void
 */
function initValidation() {
    page_elements.update_profile.form.validate({
        ignore: "",
        rules: {
            first_name: {
                required: true,
                maxlength: 150,
            },
            last_name: {
                required: true,
                maxlength: 150,
            },
            email: {
                required: true,
                email: true,
            },
            mobile: {
                required: true,
            },

            gender: {
                required: true,
            },
            title: {
                required: true,
            },
            destination: {
                required: true,
            },
            country_of_origin: {
                required: true,
            },
            state_of_origin: {
                required: true,
            },
        },
        errorElement: "span",
        errorPlacement: function (error, element) {
            if ($(element).attr("name") == "first_name") {
                element
                    .parent()
                    .siblings(".js-error-msg")
                    .html(error.text())
                    .removeClass("hide");
            } else {
                element
                    .siblings(".js-error-msg")
                    .html(error.text())
                    .removeClass("hide");
            }
        },
        highlight: function (element, errorClass, validClass) {
            if ($(element).attr("name") == "first_name") {
                $(element)
                    .addClass("is-invalid")
                    .parent()
                    .siblings(".js-error-msg")
                    .removeClass("hide");
            } else {
                $(element)
                    .addClass("is-invalid")
                    .siblings(".js-error-msg")
                    .removeClass("hide");
            }
        },
        unhighlight: function (element, errorClass, validClass) {
            if ($(element).attr("name") == "first_name") {
                $(element)
                    .removeClass("is-invalid")
                    .parent()
                    .siblings(".js-error-msg")
                    .addClass("hide");
            } else {
                $(element)
                    .removeClass("is-invalid")
                    .siblings(".js-error-msg")
                    .addClass("hide");
            }
        },
    });

    page_elements.update_password.form.validate({
        ignore: "",
        rules: {
            current_password: {
                minlength: 8,
            },
            new_password: {
                required: true,
                minlength: 8,
            },
            confirm_password: {
                required: true,
                minlength: 8,
                equalTo: "#new_password",
            },
        },
        errorElement: "span",
        errorPlacement: function (error, element) {
            if ($(element).attr("name") == "current_password") {
                element
                    .parent()
                    .siblings(".js-error-msg")
                    .html(error.text())
                    .removeClass("hide");
            } else {
                element
                    .siblings(".js-error-msg")
                    .html(error.text())
                    .removeClass("hide");
            }
        },
        highlight: function (element, errorClass, validClass) {
            if ($(element).attr("name") == "current_password") {
                $(element)
                    .addClass("is-invalid")
                    .parent()
                    .siblings(".js-error-msg")
                    .removeClass("hide");
            } else {
                $(element)
                    .addClass("is-invalid")
                    .siblings(".js-error-msg")
                    .removeClass("hide");
            }
        },
        unhighlight: function (element, errorClass, validClass) {
            if ($(element).attr("name") == "current_password") {
                $(element)
                    .removeClass("is-invalid")
                    .parent()
                    .siblings(".js-error-msg")
                    .addClass("hide");
            } else {
                $(element)
                    .removeClass("is-invalid")
                    .siblings(".js-error-msg")
                    .addClass("hide");
            }
        },
    });
}

////////// UpdateProfile /////////////////////////

/**
 * Update Profile Data
 * @param {JSON} event
 */
function updateProfile(event) {
    // if (!$(this).valid()) {
    //     return false;
    // }
    event.preventDefault();
    let form_data = new FormData($(this)[0]),
        form_action = $(this).attr("data-action");

    $(this).find(".ui-error").addClass("hide");
    //disable form, submit btn and show loader icon
    $(event.target)
        .find('button[type="submit"]')
        .addClass("ui-show-loader")
        .attr("disabled", "disabled")
        .end();
    $(".is-invalid, .ui-invalid").removeClass("is-invalid");
    $(".js-error-msg, .js-common-error").addClass("hide");
    $("#email, #phone").prop("readonly", true);
    grecaptcha.ready(function () {
        grecaptcha
            .execute(recaptcha_site_key, {
                action: "submit",
            })
            .then(function (token) {
                // Add your logic to submit to your backend server here.
                form_data.append("captcha_token", token);
                CommonMethods.ajax({
                    url: form_action,
                    type: "POST",
                    data: form_data,
                    //success: successUpdateHandler.bind(this),
                    success: function (reponse) {
                        successUpdateHandler(reponse);
                        disableFormFields();
                    },
                    error: errorUpdateHandler.bind(this),
                    complete: function () {
                        $(event.target)
                            .find('button[type="submit"]')
                            .removeClass("ui-show-loader")
                            .removeAttr("disabled")
                            .end();
                    },
                });
            });
    });
}

/* Disable form fields */
function disableFormFields() {
    $("#first_name").prop("readonly", true);
    $("#last_name").prop("readonly", true);
    $("#month").prop("disabled", true);
    $("#date").prop("disabled", true);
    $("#year").prop("disabled", true);
    $("#title").prop("disabled", true);
    $("#destination").prop("disabled", true);
    $("#origin_state").prop("disabled", true);
    $("#origin_country").prop("disabled", true);
    $("#inlineRadio1").prop("disabled", true);
    $("#inlineRadio2").prop("disabled", true);
    $("#inlineRadio3").prop("disabled", true);
    $("#inlineRadio4").prop("disabled", true);
    $("#inlineRadio5").prop("disabled", true);
    $("#inlineRadio6").prop("disabled", true);
    $("#inlineRadio7").prop("disabled", true);
    $("#email").prop("disabled", true);
    $("#phone").prop("disabled", true);
    $("#comment").prop("readonly", true);
    $(".save-button").addClass("hide");
    $(".edit-profile").removeClass("hide");
    $(".ui-profile-card").removeClass("ui-profile-edit-active");
}
////////// changePassword /////////////////////////

/**
 * Update Password
 * @param {JSON} event
 */
function updatePassword(event) {
    if (!$(this).valid()) {
        return false;
    }
    event.preventDefault();
    let form_data = new FormData($(this)[0]),
        form_action = $(this).attr("data-action");

    //disable form, submit btn and show loader icon
    $(event.target)
        .find('button[type="submit"]')
        .addClass("ui-show-loader")
        .attr("disabled", "disabled")
        .end()
        .find("input,select")
        .attr("readonly", "readonly");
    $(".is-invalid").removeClass("is-invalid");
    $(".js-error-msg, .js-common-error").addClass("hide");

    grecaptcha.ready(function () {
        grecaptcha
            .execute(recaptcha_site_key, { action: "submit" })
            .then(function (token) {
                // Add your logic to submit to your backend server here.
                form_data.append("captcha_token", token);
                CommonMethods.ajax({
                    url: form_action,
                    type: "POST",
                    data: form_data,
                    success: successUpdatePasswordHandler.bind(this),
                    error: errorUpdatePasswordHandler.bind(this),
                    complete: function () {
                        $(event.target)
                            .find('button[type="submit"]')
                            .removeClass("ui-show-loader")
                            .removeAttr("disabled")
                            .end()
                            .find("input,select")
                            .removeAttr("readonly");
                    },
                });
            });
    });
}

/**
 * Success handle for update profile
 *
 * @author Niyas <niyas@webandcrafts.in>
 *
 * @param {JSON} response
 */
function successUpdateHandler(response) {
    if (response.success) {
        var first_name = $("#first_name").val();
        var last_name = $("#last_name").val();
        $("#prof-text").html(
            first_name.substring(0, 1) + " " + last_name.substring(0, 1)
        );
        $("#ui-profile-name").html(first_name + " " + last_name);
        $("#userName").html(first_name + " " + last_name);
        if ($(window).width() > 767) {
            $(".ui-profile-email-validation").removeClass("d-none");
            $(".ui-success-msg").removeClass("d-none");
            setTimeout(function () {
                $(".ui-profile-email-validation").addClass("d-none");
            }, 5000);
        } else {
            $(".ui-profile-email-validation").removeClass("d-none");
            $(".ui-success-msg").removeClass("d-none");
            setTimeout(function () {
                $(".ui-success-msg").addClass("d-none");
            }, 5000);
        }
        if (response.data.isProfileCompleted) {
            $(
                "li.list-group-item, #navbarNavDropdown, .ui-navbar2"
            ).removeClass("ui-list-group-of-items");
        } else {
            $(
                "li.list-group-item:not(:first):not(:last), #navbarNavDropdown, .ui-navbar2"
            ).addClass("ui-list-group-of-items");
        }
    }
}

/**
 * Success handle for update password
 *
 * @author Niyas <niyas@webandcrafts.in>
 *
 * @param {JSON} response
 */
function successUpdatePasswordHandler(response) {
    if (response.success) {
        $(".ui-error").addClass("hide");
        $("#updatePassword")[0].reset();
        // page_elements.update_profile.form[0].reset(); // reset profile form
        CommonMethods.alert(
            "Success",
            "Password updated sucessfully!",
            "success",
            {
                timer: 5000,
            }
        );
    }
}

/**
 * Error handle for update profile
 *
 * @author Niyas <niyas@webandcrafts.in>
 *
 * @param {JSON} response
 */
function errorUpdateHandler(response) {
    if (response.status == 422) {
        $(".js-common-error")
            .text("All inputs are required")
            .removeClass("hide");
        $.each(response.responseJSON.errors, function (key, value) {
            $('[name="' + key + '"]').addClass("is-invalid");
            //.next().find('.ui-error').removeClass('hide').html(value.join('<br>'));
            $('[name="' + key + '"]')
                .parent()
                .addClass("ui-invalid")
                .find(".ui-error")
                .removeClass("hide")
                .html(value.join("<br>"));
            if (key == "gender") {
                $('[name="' + key + '"]')
                    .parents(".js-gender")
                    .find(".ui-error")
                    .removeClass("hide")
                    .html(value.join("<br>"));
            }
        });
    } else {
        $(".js-common-error")
            .text("Something went wrong!!! Please try again")
            .removeClass("hide");
    }
}

/**
 * Error handle for update password
 *
 * @author Niyas <niyas@webandcrafts.in>
 *
 * @param {JSON} response
 */
function errorUpdatePasswordHandler(response) {
    if (response.status == 422) {
        $(".js-common-error")
            .text("All inputs are required")
            .removeClass("hide");
        $.each(response.responseJSON.errors, function (key, value) {
            $('[name="' + key + '"]')
                .addClass("is-invalid")
                .next()
                .removeClass("hide")
                .html(value.join("<br>"));
        });
    } else {
        //$('.js-common-error').text('Current password incorrect').removeClass('hide');
        $("#current_password")
            .next()
            .text("Current password incorrect")
            .removeClass("hide");
    }
}

////////// Common ////////////////

/**
 * Convert input to contry code
 *
 * @param element jsinput - input element
 */
function countryCodeInput(jsinput) {
    let iti = window.intlTelInput(jsinput[0], {
        separateDialCode: true,
        autoPlaceholder: "off",
        utilsScript:
            "https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.3/build/js/utils.js",
        initialCountry: "auto",
        geoIpLookup: function (callback) {
            $.get("https://ipinfo.io", function () {}, "jsonp").always(
                function (resp) {
                    var countryCode =
                        resp && resp.country ? resp.country : "in";
                    callback(countryCode);
                }
            );
        },
    });

    let country_input = jsinput.parents("form").find(".js-country-code input");
    // listen to the telephone input for changes
    jsinput.on("countrychange", function (e) {
        country_input.val(iti.getSelectedCountryData().dialCode);
    });
}

$(".ui-select-date select").on("change", function () {
    var removeValidClass = true;
    if ($(this).val()) {
        $(this).removeClass("is-invalid");
        if ($(this).parent("div").find("select.is-invalid").length > 0) {
            removeValidClass = false;
        }
    }

    if (removeValidClass) {
        $(this).parent("div").removeClass("ui-invalid");
    }
});

$('div.js-gender input[type="radio"]').on("change", function () {
    if ($(this).is(":checked")) {
        $(this)
            .parents("div.js-gender")
            .find(".is-invalid")
            .removeClass("is-invalid");
    }
});

$('#updateProfile input[type="text"]').on("change", function () {
    if ($(this).val()) {
        $(this).removeClass("is-invalid");
    }
});

$("#updateProfile .ui-select select").on("change", function () {
    if ($(this).val()) {
        $(this).removeClass("is-invalid");
    }
});

$(".js-btn-add-email").on("click", function () {
    $("#auth_check_form").attr("data-type", "change-email");
    $("#security-tab").tab("show");
});

$(document).on(
    "change",
    ".ui-invalid input, .ui-invalid select, .ui-invalid textarea",
    function () {
        $(this).parents(".ui-invalid").removeClass("ui-invalid");
    }
);

$(document).on("change", ".form-check-input", function () {
    let inName = $(this).attr("name");
    $('input.is-invalid[name="' + inName + '"]').removeClass("is-invalid");
});
$(document).on("change", ".is-invalid", function () {
    $(this).removeClass("is-invalid");
});

$(document).on(
    "keypress",
    "#auth_check_form #email_mobile_username",
    function (e) {
        if (e.which == 13) {
            e.preventDefault();
            $("#auth_check_form .ui-request-otp.js-request-otp").trigger(
                "click"
            );
        }
    }
);
